// @flow
import React from 'react';
import withHeaderAndFooter from '../../HOCs/withHeaderAndFooter';

import {SearchSection} from './SearchSection/SearchSection';
import {PopularSites} from './PopularSites/PopularSites';
import FloatingAddWOT from '../../components/FloatingAddWOT/FloatingAddWOT';

type Props = {
    title: string,
    target: string,
    isMobileUser: boolean
}

const ErrorPage = ({title, target, isMobileUser}: Props): Object => {
    return (
        <React.Fragment>
            { !isMobileUser ? <FloatingAddWOT isHidden={false} pageTrackName="NoResults" /> : null }
            <SearchSection title={title} target={target} isMobileUser={isMobileUser} />
            <PopularSites isMobileUser={isMobileUser} />
        </React.Fragment>
    );
};

export default withHeaderAndFooter(ErrorPage);
